import { render, staticRenderFns } from "./NumerosLlamados.vue?vue&type=template&id=36bafab0&scoped=true"
import script from "./NumerosLlamados.vue?vue&type=script&lang=js"
export * from "./NumerosLlamados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36bafab0",
  null
  
)

export default component.exports